import { render, staticRenderFns } from "./MenuItemSecondary.vue?vue&type=template&id=21a794d6&scoped=true&"
import script from "./MenuItemSecondary.vue?vue&type=script&lang=js&"
export * from "./MenuItemSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a794d6",
  null
  
)

export default component.exports